import { Snippet } from '../../dataModels';

export const rollupMatrixSnippet: Snippet = {
  shiftsummaryDisplyId: 'be9ecf6b-5875-ec11-913d-005056b29cce',
  name: 'A_TEST_ROLLUP_MATRIX',
  displayName: 'A_TEST_ROLLUP_MATRIX',
  description: null,
  order: 8,
  type: 'RollupMatrix',
  count: 0,
  configuration: {
    columnCount: 2,
    rowTitleKey: 'TEST Column 1',
    columns: [
      {
        id: 1,
        name: 'TEST Column 1',
        displayName: 'TEST Column 1',
        controlType: 'Static Text',
        controlValues: [],
        visible: true,
      },
      {
        id: 2,
        name: 'TEST Column 2',
        displayName: 'TEST Column 2',
        controlType: 'Static Text',
        controlValues: [],
        visible: true,
      },
    ],
    matrixCells: [
      {
        rowNumber: 1,
        colNumber: 1,
        controlType: 'Text',
        controlValues: null,
      },
      {
        rowNumber: 1,
        colNumber: 2,
        controlType: 'Text',
        controlValues: null,
      },
      {
        rowNumber: 2,
        colNumber: 1,
        controlType: 'Text',
        controlValues: null,
      },
      {
        rowNumber: 2,
        colNumber: 2,
        controlType: 'Text',
        controlValues: null,
      },
    ],
  },
  data: [
    {
      rowCount: 2,
      rollupDetails: {
        SourceSnippetDisplayID: 'odsjamlsdms',
        Asset: 'Asset',
        Author: 'Author',
        CreatedTime: '1/14/2022 4:38:37 PM',
      },
      rowData: [
        {
          'TEST Column 1': 'null 1',
          'TEST Column 2': 'null 1',
        },
        {
          'TEST Column 1': 'null 2',
          'TEST Column 2': 'null 2',
        },
      ],
    },
  ],
  groupSnippets: null,
};
